import {isCopilot} from '@github-ui/assignees/copilot-user'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {Label, Link} from '@primer/react'

export function Author({login}: {login?: string | null}) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()
  if (!login) return null

  const isAI = isCopilot(login)
  const profileUrl = `/${isAI ? 'apps/' : ''}${login}`
  const hovercardAttributes = isAI
    ? getHovercardAttributesForType('copilot', {botSlug: login})
    : getHovercardAttributesForType('user', {login})

  return (
    <span>
      <Link href={profileUrl} {...hovercardAttributes} className="fgColor-default">
        <strong>{login}</strong>
      </Link>
      {isAI && (
        <Label variant="secondary" className="ml-1">
          AI
        </Label>
      )}
    </span>
  )
}
